import axios from 'axios'
import request from '../servises/request'

export function getDiscounts(pr) {
    let params
    if (pr) {
        params = `?${pr}`
    }
    return request({
        url: pr ? `/discount${params}` : '/discount',
        method: 'GET'
    })
}

export function createDiscount(data) {
    return request({
        url: `/discount`,
        method: 'POST',
        data: data
    })
}

export function deleteDiscount(discount_id) {
    return request({
        url: `/discount/${discount_id}`,
        method: 'DELETE'
    })
}

export function discountShow(discount_id) {
    return request({
        url: `/discount/${discount_id}`,
        method: 'GET'
    })
}

export function updateDiscount(discountId, data) {
    return request({
        url: `/discount/${discountId}`,
        method: 'PATCH',
        data: data
    })
}
